import AutoAwesomeTwoTone from '@mui/icons-material/AutoAwesomeTwoTone';
import { Box, Typography } from '@mui/material';
import React from 'react';

/**
 * "mintlyAI" badge, shown on AI-generated insight sections.
 *
 * The old version clipped a #2563eb → #7c3aed gradient to the text — a third
 * off-brand gradient, in a design system that reserves gradients for the brand
 * mark. This is the gold/teal tint pill from the design guide: two ~10% tints,
 * so it reads as one quiet wash rather than a colour ramp.
 */
const MintlyAIBadge: React.FC = () => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '5px 11px',
      borderRadius: 'var(--border-radius-full)',
      background: 'linear-gradient(135deg, var(--gold-tint), var(--teal-tint))',
      border: '1px solid var(--gold-line)',
      color: 'var(--gold)',
    }}
  >
    <AutoAwesomeTwoTone sx={{ fontSize: 'var(--font-size-sm-plus)', color: 'var(--gold)' }} />
    <Typography
      component="span"
      sx={{
        fontSize: 'var(--fs-chip)',
        fontWeight: 700,
        letterSpacing: 'var(--ls-micro)',
        lineHeight: 1,
        color: 'inherit',
      }}
    >
      mintlyAI
    </Typography>
  </Box>
);

export default MintlyAIBadge;
